module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_storecategories", [["div",{"class":"site-page store-list no-pb"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title","data-fox-alias":"storeTitle"},[["p",{},[["textNode",{"text":"Shop"}]]]]]]]]],["section",{"class":"store-categories-wrapper"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/storeCategories.tpl
// module id = 773
// module chunks = 4